<template>
  <div class="validator-container">
    <div class="validator-inner">

      <div class="flex flex-align-center flex-justify-between">
        <div class="validator-steps">
          <div
            class="validator-step"
            :class="stepActiveClass(1)">
            <div class="step-num">
              <span>1</span>
            </div>
            <span class="step-label">
              Flock
            </span>
          </div>
          <div
            class="validator-step"
            :class="stepActiveClass(2)">
            <div class="step-num">
              <span>2</span>
            </div>
            <span class="step-label">
              Address
            </span>
          </div>
          <div
            class="validator-step"
            :class="stepActiveClass(3)">
            <div class="step-num">
              <svg style="display: block; height: 1em; width: 1em;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="currentColor" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
              </svg>
            </div>
          </div>
        </div>

        <button
          v-if="confirmed"
          type="button"
          class="button button-alt button-thin button-smallest"
          @click="prevStep">
          Edit
        </button>
      </div>

      <div style="margin-top: 1em;">
        <component
          ref="step"
          :is="activeComponent"
          :checkPremise="checkPremise"
          :flock="flock"
          v-on="$listeners"
        />
      </div>

      <div class="flex flex-align-center"
        style="margin-top: 2em; justify-content: flex-end;"
        v-if="!confirmed">
        <button
          type="button"
          class="button button-subtle button-thin button-smallest"
          style="width: 3em;"
          title="Back to previous step"
          :class="{'invisible': activeStep === 0}"
          :disabled="activeStep === 0"
          @click="prevStep">
          &larr;
        </button>
        <button
          type="button"
          class="button button-subtle button-thin flex flex-justify-center"
          style="width: 6em; margin-left: 1em;"
          @click="nextStep">
          <span :class="[loading ? 'hidden' : 'show']">
            {{ activeStep === Object.keys(steps).length - 2 ? 'Confirm' : 'Next' }}
          </span>
          <SvgSpinner :class="[!loading ? 'hidden' : 'show']"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FlockValidatorAddress from './FlockValidatorAddress';
import FlockValidatorFlock from './FlockValidatorFlock';
import FlockValidatorInfo from './FlockValidatorInfo';
import SvgSpinner from './SvgSpinner';

export default {
  components: {
    'Address': FlockValidatorAddress,
    'Flock': FlockValidatorFlock,
    'Info': FlockValidatorInfo,
    SvgSpinner,
  },

  props: {
    checkPremise: {
      default: false,
      type: Boolean,
    },

    flock: {
      type: Object,
      default: () => {
        return {
          id: '',
          premise_id: '',
          address: {
            first_name: '',
            last_name: '',
            street: '',
            city: '',
            state: '',
            zip: '',
          },
          confirm: false,
        };
      },
    },
  },

  data() {
    return {
      activeStep: 0,
      loading: false,
      steps: {
        'Flock': 'Flock',
        'Address': 'Address',
        'Info': null,
      },
    };
  },

  async mounted() {
    this.$nextTick(async () => {
      if(this.flock.id !== '') {
        do {
          await this.nextStep();
        } while(
          Object.keys((this.$refs.step || {}).errors || {}).length === 0
          && this.activeStep < Object.keys(this.steps).length - 1
        );
      }
    });
  },

  methods: {
    async nextStep() {
      this.loading = true;

      if(await this.$refs['step'].validate()) {
        this.activeStep++;

        document.activeElement.blur();
      }

      this.loading = false;
    },

    prevStep() {
      this.activeStep--;

      document.activeElement.blur();
    },

    stepActiveClass(index) {
      let classes = [];
      const step = this.activeStep + 1;

      if(index < step) {
        classes.push('past-step');
      }

      if(index === step) {
        if(step !== 5) {
          classes.push('active-step');
        } else {
          classes.push('completed-step');
        }
      }

      return classes.join(' ');
    },
  },

  computed: {
    activeComponent() {
      return Object.keys(this.steps)[this.activeStep];
    },

    confirmed() {
      return this.activeStep === Object.keys(this.steps).length - 1;
    },
  },

  watch: {
    flock: {
      deep: true,
      handler() {
        if(this.flock.id === '') {
          this.activeStep = 0;
        }
      },
    }
  },
}
</script>
